import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios_instance from '../api/axios_instance';

export const fetchSettings = createAsyncThunk('settings/fetch', async () => {
  const res = await axios_instance.get('/api/settings');
  return res.data;
});

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    deliveryFee: 7,
    loaded: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSettings.fulfilled, (state, action) => {
      state.deliveryFee = action.payload.deliveryFee;
      state.loaded = true;
    });
  },
});

export default settingsSlice.reducer;
